/** Persistent layout for Beat Shop routes — shared preview player across pages. */
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { PreviewPlayerProvider, usePreviewPlayer } from './PreviewPlayer';

/** Keep the shop filtered queue on browse + beat detail; clear it on vault/sell. */
const ShopQueueGuard: React.FC = () => {
  const { pathname } = useLocation();
  const player = usePreviewPlayer();
  const keepShopQueue =
    pathname === '/store/beat-shop' || pathname.startsWith('/store/beat-shop/beats/');

  useEffect(() => {
    if (!keepShopQueue) player.setQueue([]);
  }, [keepShopQueue, player.setQueue]);

  return null;
};

const BeatShopLayout: React.FC = () => (
  <PreviewPlayerProvider>
    <ShopQueueGuard />
    <Outlet />
  </PreviewPlayerProvider>
);

export default BeatShopLayout;
